import React from 'react'
import styled from 'styled-components'
import { Chiclet, type ChicletTone } from 'sutra/components/Chiclet/Chiclet'

import { fontSizeM } from 'assets/styles/variables'

type Props = {
  searchCriteria: Record<string, string[]>
}

const keywordTone = (operator: string): ChicletTone => {
  if (operator.startsWith('Excludes')) return 'danger'
  return operator === 'Includes all' ? 'emerald' : 'blue'
}

export const AlertKeywordSection: React.FC<Props> = ({ searchCriteria }) => (
  <KeywordSection>
    {Object.entries(searchCriteria).map(
      ([operator, keywords]) =>
        keywords.length > 0 && (
          <div key={operator}>
            <KeywordGroupLabel>{operator}:</KeywordGroupLabel>
            <KeywordTags>
              {keywords.map((keyword, index) => (
                <Chiclet key={index} $tone={keywordTone(operator)}>
                  {keyword}
                </Chiclet>
              ))}
            </KeywordTags>
          </div>
        ),
    )}
  </KeywordSection>
)

const KeywordSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
  font-size: ${fontSizeM};
`

const KeywordGroupLabel = styled.div`
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #666666;
`

const KeywordTags = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`
